import { duplicateClientNutritionPlanForClient } from "../plans/nutritionPlanAssignments";
import { getNutritionPlanDisplayName } from "../plans/nutritionPlanNameUtils";

function normalizeEditingPlanId(planLike) {
  return String(planLike?.id ?? planLike?.client_plan_id ?? "").trim();
}

export function openDuplicatedClientNutritionPlan(client, duplicatedPlan) {
  const duplicatedPlanId = normalizeEditingPlanId(duplicatedPlan);
  if (!duplicatedPlanId) {
    return false;
  }

  client?.setProperty?.("nutritionEditingPlanId", duplicatedPlanId);
  return true;
}

export async function duplicateClientNutritionPlanFromScreen({
  client,
  language = "en",
  sourcePlan,
  sourceClientPlanStore,
  shouldOpenDuplicate = false,
  showToast = null,
  duplicatePlan = duplicateClientNutritionPlanForClient,
  openDuplicatedPlan = openDuplicatedClientNutritionPlan,
  getDuplicatedPlanDisplayName = getNutritionPlanDisplayName,
}) {
  const duplicatedPlan = await duplicatePlan({
    client,
    language,
    sourcePlan,
    sourceClientPlanStore,
  });

  if (shouldOpenDuplicate) {
    openDuplicatedPlan(client, duplicatedPlan);
  }

  showToast?.("clientNutritionPlanDuplicateSuccessTitle-string", {
    type: "info",
    title: "clientNutritionPlanDuplicateSuccessTitle-string",
    description: "clientNutritionPlanDuplicateSuccessDescription-string",
    variables: {
      name: getDuplicatedPlanDisplayName(duplicatedPlan, language),
    },
  });

  return duplicatedPlan;
}
